import {by} from '../data/by'
import {ru} from '../data/ru'
import './confirm.css'

export default function Confirm({additional, close}) {

  const funcYes = additional.funcYes;
  const language = localStorage.getItem('lang') === 'ru' ?  ru.RoleIdOne: by.RoleIdOne;
  const text = additional.text

  return (
    <div className='confirm'>
      <p style={{color:'black'}}>{text}</p>
      <div className='confirm_buttons'>
      <button className="confirm_button" onClick={() => funcYes()}>{language.buttonYes}</button>
      <button className="confirm_button" onClick={() => close()}>{language.buttonNo}</button>
      </div>
    </div>
  )
}